import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
    // localStorage.removeItem('token');
    // localStorage.removeItem('user');
    // localStorage.removeItem('permissions');
    navigate('/login');
  }, [navigate]);

  // Return null as this component doesn't render anything
  return null;
};

export default Logout;
